<div class="p-2 text-white bg text-center" style="margin-bottom:0;">
	<div class="col-12">
		<h2 class="text-center" style="color: black;"><img src="./../../assets/img/activelogo.webp" width="3%" height="3%" alt="" class="foot-logo">&nbsp;<strong>Get In Touch</strong></h2>
	</div>
</div>
<div class="p-3 bg text-white text-center" style="margin-bottom:0"  style="border-radius: 65px;">
	<div class="container-fluid col-xs-12 mb-3" style="width: 100%;">
		<div class="container">
			<div class="row">
				<!-- Services Section -->
				<div class="col-md-4 col-sm-12 text-left">
					<h4 class="text-uppercase font-weight-bold" style="color: black;"> <i class="fa fa-cogs" aria-hidden="true"></i>&nbsp;<strong>Services</strong></h4>
					<hr class="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style="width: 70px;">
					<ul class="list-unstyled">
						<li><a style="color: black;" class="font-weight-light"><span>&#8594;</span>&nbsp;Multi-brand Piston</a></li>
						<li><a style="color: black;" class="font-weight-light"><span>&#8594;</span>&nbsp;Multi-brand Air Dryer</a></li>
						<li><a style="color: black;" class="font-weight-light"><span>&#8594;</span>&nbsp;Multi-brand Oil Chiller</a></li>
						<li><a style="color: black;" class="font-weight-light"><span>&#8594;</span>&nbsp;Air Pipe-line Works</a></li>
						<li><a style="color: black;" class="font-weight-light"><span>&#8594;</span>&nbsp;Panel Air-cooler</a></li>
						<li><a style="color: black;" class="font-weight-light"><span>&#8594;</span>&nbsp;Multi-brand Screw Air</a></li>
					</ul>
				</div>
		
				<!-- Company Section -->
				<div class="col-md-4 col-sm-12 text-left">
					<h4 class="text-uppercase font-weight-bold" style="color: black;"><i class="fa fa-building" aria-hidden="true"></i>&nbsp;<strong>Company</strong></h4>
					<hr class="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style="width: 70px;">
					<ul class="list-unstyled">
						<li><a routerLink="/home-page" class="service-text font-weight-light" style="color: black;"><i class="fa fa-home"></i>
							&nbsp;Home</a></li>
						<li><a routerLink="/verticals" class="service-text font-weight-light" style="color: black;"><i class="fa fa-cogs"></i>&nbsp; Our Services</a></li>
						<li><a routerLink="/ourproducts" class="service-text font-weight-light" style="color: black;"><i class="fa fa-info-circle"></i>&nbsp; Our Products</a></li>
						<li><a routerLink="/clients" class="service-text font-weight-light" style="color: black;"><i class="fa fa-image"></i>&nbsp; Gallery</a></li>
						<li><a routerLink="/contact-us" class="service-text font-weight-light" style="color: black;"> <span class="fa fa-envelope"></span>&nbsp; Contact Us</a></li>
					</ul>
				</div>
		
				<!-- Contact Us Section -->
				<div class="col-md-4 col-sm-12 justify-content text-left">
					<h4 class="text-uppercase font-weight-bold" style="color: black;"><i class="fa fa-phone" aria-hidden="true"></i>&nbsp;<strong>Contact Us</strong></h4>
					<hr class="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style="width: 70px;">
					<address class="font-weight-light" style="color: black;">
						<p><i class="fa fa-home mr-3 foot-fa" style="color: black;"></i> 
						No.84 Gangai Amman Koil Street, Near Amman Koil, Ayyapanthangal, Chennai - 56, Tamilnadu, India.</p>
						<p>
							<i class="fa fa-envelope mr-3 foot-fa" style="color: black;"></i>
							<a href="mailto:activemultienterprises@gmail.com" class="mail-text" style="color: black;">activemultienterprises@gmail.com</a>
						</p>
						<p>
							<i class="fa fa-mobile mr-3 foot-fa" style="color: black;"></i>
							<a href="tel:+918489359948" class="mail-text" style="color: black;">+91 84893 59948</a>, 
							<a href="tel:+916385131365" class="mail-text" style="color: black;">+91 63851 31365</a>
						</p>
					</address>
				</div>
			</div>
		</div>
		
		

	<!-- <div class="h4 text-left" style="color: #000000;">
		Powered By-
		<a href="#" target="_blank" class="text-danger font-weight-light">
			
		</a>
	</div> -->

	<!-- <div class="row">
		<div class="col-md-6 col-sm-6 col-xs-12 d-none d-sm-block">
			<h5 class="mt-2 pt-3 text-center" style="color: black;">
				<i class="fa fa-copyright"></i>
				2025 ACTIVE MULTI ENTERPRISES
				<sup style="font-size: 5px; padding: 0.3%;" style="color: black;">
					<i class="fa fa-registered fa-1x" aria-hidden="true"></i>
				</sup> - All Rights Reserved
			</h5>
		</div>
		<div class="col-md-6 col-sm-6 col-xs-12 d-block d-sm-none">
			<h6 class="mt-1 pt-2 text-center" style="color: black;">
				<i class="fa fa-copyright" aria-hidden="true"></i>
				2025 ACTIVE MULTI ENTERPRISES.,<div style="text-align: center;" style="color: black;">All Rights Reserved</div>
			</h6>
		</div>
	</div> -->
	
		<!-- <div class="col-md-6 col-sm-12 col-xs-12 text-center">
			<div id="social">
				<a class="fa fa-facebook fa-lg service-text" target="_blank" href="https://www.facebook.com/guru.aswath?mibextid=ZbWKwL"></a>&nbsp;
				<a class="fa fa-youtube-play fa-lg service-text" target="_blank" href="https://www.youtube.com/@RvProductions0806"></a>&nbsp;
				<a class="fa fa-instagram fa-lg service-text" target="_blank" href="
				https://www.instagram.com/gnanaguru_director?igsh=MWNoN2cyd2g2dHQ1eg=="></a>&nbsp;
				<a class="fa fa-whatsapp fa-lg service-text" target="_blank" href="https://wa.me/+91 9843683020?text=Hello%20there!%20I%20want%20to%20know%20more%20about%20your%20services."></a>&nbsp;
			</div>
		</div> -->
	<div class="col-xs-12 justify-content text-center d-block">
		<!-- <p class="mt-2">Designed by :</p> -->
		<a href="https://www.annaasilicontechnology.com" target="_blank" style="color: #000000;">
			Designed by : Annaa Silicon Technology Pvt Ltd.,
			<sup>
				<i class="fa fa-registered" aria-hidden="true"></i>
			</sup>
		</a>
		<br>
	</div>
</div>